import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getApiBaseCandidates } from '../config/appConfig';

const VISITOR_STORAGE_KEY = 'fw_site_visitor_token';
const ADMIN_ROUTE_PREFIX = '/portal/nebula/future-world-content-console-20260325-x7m9k4q2-admin';

let lastTrackedSignature = '';
let lastTrackedAt = 0;

const createVisitorToken = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const getVisitorToken = () => {
  const existing = window.localStorage.getItem(VISITOR_STORAGE_KEY);
  if (existing) return existing;
  const next = createVisitorToken();
  window.localStorage.setItem(VISITOR_STORAGE_KEY, next);
  return next;
};

const postVisit = async (payload: Record<string, unknown>) => {
  const bases = getApiBaseCandidates();
  for (const base of bases) {
    try {
      await fetch(`${base}/analytics/track/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      });
      return;
    } catch {
      // Try the next configured backend base.
    }
  }
};

export const usePageAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (location.pathname.startsWith(ADMIN_ROUTE_PREFIX)) return;

    const signature = `${location.pathname}${location.search}`;
    const now = Date.now();
    if (signature === lastTrackedSignature && now - lastTrackedAt < 1000) return;

    lastTrackedSignature = signature;
    lastTrackedAt = now;

    void postVisit({
      path: `${location.pathname}${location.search}`,
      page_title: document.title,
      referrer: document.referrer,
      visitor_token: getVisitorToken(),
      language: document.documentElement.lang || navigator.language || '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      screen_width: window.screen?.width ?? null,
      screen_height: window.screen?.height ?? null,
    });
  }, [location.pathname, location.search]);
};
